import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "BD",
  "use": "BD-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"BD\"><path fill=\"#006A4D\" d=\"M36 27c0 2.209-1.791 4-4 4H4c-2.209 0-4-1.791-4-4V9c0-2.209 1.791-4 4-4h28c2.209 0 4 1.791 4 4v18z\" /><circle fill=\"#F42A41\" cx=\"16\" cy=\"17.5\" r=\"7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol